import React from "react";
import ColorSwatch from "./ColorSwatch";

const ShadeDisplay = ({
  shades,
  selectedColor,
  handleColorClick,
  visibleFields,
  colorBlindnessType,
  isDark,
  addColorToPalette,
  addColorToCustomPalette,
}) => (
  <div className="mt-0">
    <div className="flex flex-wrap gap-2">
      {shades.map((shade) => (
        <ColorSwatch
          key={shade.number}
          color={shade.color}
          number={shade.number}
          onClick={handleColorClick}
          isBaseColor={
            shade.color.toLowerCase() === selectedColor.toLowerCase()
          }
          visibleFields={visibleFields}
          colorBlindnessType={colorBlindnessType}
          isDark={isDark}
          onAddToPalette={addColorToPalette}
          onAddToCustomPalette={addColorToCustomPalette}
        />
      ))}
    </div>
  </div>
);

export default ShadeDisplay;
